import { EntitlementRedeemResponse } from '@/features/membership/shared/api/redeem-membership-tokens-for-game';
import {
  MembershipTokenAlreadyOwnedError,
  MembershipTokenRedeemError,
} from '@/features/membership/shared/errors/membership-token-errors';

export const redeemMembershipTokens = async (
  gameId: string,
  locale: string,
): Promise<EntitlementRedeemResponse> => {
  const response = await fetch('/api/membership/tokens', {
    method: 'POST',
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
    },
    // The handler cannot read the site locale itself, so it travels in the body.
    body: JSON.stringify({ productKey: gameId, locale }),
  });
  let payload: unknown = null;

  try {
    payload = await response.json();
  } catch (error) {
    if (response.ok) {
      throw error;
    }
  }

  if (!response.ok) {
    const message =
      (payload && typeof (payload as { error?: string }).error === 'string'
        ? (payload as { error: string }).error
        : null) || 'Redeem failed';

    if (response.status === 409) {
      throw new MembershipTokenAlreadyOwnedError(message);
    }

    throw new MembershipTokenRedeemError(message, response.status);
  }

  return payload as EntitlementRedeemResponse;
};
